import InsightsRelatedContent from './InsightsRelatedContent';

export { type InsightsRelatedContentProps } from './InsightsRelatedContent';
export default InsightsRelatedContent;
